module.exports = __webpack_public_path__ + "static/media/arrow-left-white.b5e40e4b.svg";